import { Box } from '@mui/material';
import SearchField from 'components/controls/SearchField';
import { func, string } from 'prop-types';
import React from 'react';

const Search = ({ value = '', onChange }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', mr: '20px' }}>
      <SearchField onChange={onChange} value={value} />
    </Box>
  );
};

Search.propTypes = {
  value: string,
  onChange: func.isRequired,
};

export default Search;
